// 调证用户信息 - 简体中文
export default {
  balance: {
    available: "可用余额",
    accountAssets: "账户总资产预览(USDT)",
  },
  basicInfo: {
    title: "基础信息",
    expandAll: "展开全部",
    collapseAll: "收起全部",
  },
  character: {
    addCharacter: "添加人物",
    viewDetails: "查看详情",
    syncFailed: "人物信息同步失败",
  },
  fields: {
    name: "[姓名]",
    userId: "[用户ID]",
    username: "[用户名]",
    nationality: "[国籍]",
    idNumber: "[证件号]",
    homePlace: "[籍贯]",
    sex: "[性别]",
    phone: "[手机号]",
    email: "[邮箱]",
    registerTime: "[注册时间]",
    relatedCase: "[关联案件]",
    note: "[备注]",
    deviceId: "[设备ID]",
    firstUseTime: "[首次使用时间]",
    analysisId: "[分析ID]",
    platform: "[平台]",
    bindPhoneTime: "[绑定手机时间]",
    paymentInfo: "[收款信息]",
    walletAddress: "[钱包地址]",
    usedAddress: "[使用过的地址]",
    watchedAddress: "[观察过的地址]",
    walletAccount: "[钱包账户]",
  },
  common: {
    none: "--",
    yes: "有",
    no: "无",
    noBank: "暂无查询到相关银行",
    wechat: "微信",
    alipay: "支付宝",
    moreData: "条数据，加载更多",
    collapse: "收起",
  },
};
